<template>
  <div class="form-control d-flex flex-wrap">
    <div class="tags d-flex flex-wrap">
      <div class="tag bg-primary d-flex" v-for="(tag, index) in tags" :key="index">
        <span class="align-self-center m-1">
          {{ tag }}
        </span>

        <i class="fal fa-times align-self-center m-1" @click="removeTag(index)"></i>
      </div>
    </div>
    <input
      type="text"
      v-model="value"
      :placeholder="placeHolder"
      @keyup="handleKeyUp"
      @blur="addTag"
    />
  </div>
</template>

<script>
export default {
  name: "TagsInput",
  props: {
    placeHolder: {
      type: String,
      default: "Add new tag",
    },

    delimiter: {
      type: String,
      default: ",",
    },

    data: {
      type: String,
    },
  },
  emits: ["change"],
  data() {
    return {
      tags: [],
      value: null,
    };
  },

  created() {
    if (this.data) this.tags = this.data.split(this.delimiter);
  },

  methods: {
    handleKeyUp(e) {
      let keyCodes = ["Comma", "Enter"];
      if (keyCodes.includes(e.code)) this.addTag();
    },

    addTag() {
      if (this.value && this.value.length) {
        let val = this.value.replace(this.delimiter, "");
        this.tags = this.tags.concat(val.split(this.delimiter));
        this.value = "";
        this.update();
      }
    },

    removeTag(index) {
      this.tags.splice(index, 1);
      this.update();
    },

    update() {
      this.$emit("change", this.tags.join(this.delimiter));
    },
  },

  watch: {
    data: function (newVal, oldVal) {
      if (newVal && newVal != oldVal) this.tags = newVal.split(this.delimiter);
    },
  },
};
</script>

<style scoped lang="scss">
input {
  border: none;
  outline: none;
}

.tag {
  margin: 0.25rem;
  border-radius: 0.25rem;
  text-align: center;
  color: white;
  font-size: 0.9rem;
  cursor: default;

  i {
    cursor: pointer;
  }
}
</style>
